import React, {FC, useState} from 'react'
import {TextArea} from "@fluentui/react-northstar"
import EmptyFieldError from "./EmptyFieldError"
import {FormLabel, RecognitionLabelWrapper} from "./styles"

interface Props {
    onMessageChanged: (newValue: string) => void,
    error: boolean,
    disabled?: boolean
}

const RecognitionMessage: FC<Props> = ({disabled, onMessageChanged, error}) => {
    const [message, setMessage] = useState<string>("")

    const handleTextChange = (_: any, {value}: any) => {
        setMessage(value)
        onMessageChanged(value)
    }

    return (
        <div>
            <RecognitionLabelWrapper>
                <FormLabel>
                  What did they do
                </FormLabel>
            </RecognitionLabelWrapper>
            <TextArea
                className='customPlaceholder'
                value={message}
                styles={{
                  height: "70px",
                  marginTop: "3px"
                }}
                fluid
                placeholder="Type here..."
                disabled={disabled}
                onChange={handleTextChange}
            />
            {error && <EmptyFieldError/>}
        </div>
    )
}

export default RecognitionMessage
